import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";

import Typography from "@mui/material/Typography";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import GetAppIcon from "@mui/icons-material/GetApp";

import Button from "../../components/Button";
import TableComponent from "../../components/TableComponent";
import useCrew from "../../hooks/useCrew";
import { getCrewUsersTrainings } from "../../api/training.deprecated";
import { getMoodleCourseById } from "../../api/courses";
import { useShoppingCart } from "../../context/ShoppingCartContext";
import { openExportWindow } from "../../api/";

const InscribeUser = ({ match, history }) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const onExportError = () => enqueueSnackbar(t("orders.document_not_found"), { variant: "error" });
  const [usersToInscribe, setUsersToInscribe] = useState([]);
  const [course, setCourse] = useState(null);
  const { crew } = useCrew();
  const shoppingCart = useShoppingCart();
  const trainingId = match.params.trainingId;
  const courseId = match.params.courseId;

  useEffect(() => {
    (async () => {
      const nextCourse = await getMoodleCourseById(courseId);
      setCourse(nextCourse);
      const newRes = await getCrewUsersTrainings(crew.id, crew.baseIds);
      setUsersToInscribe(newRes);
    })();
  }, [crew, courseId]);

  return (
    <>
      <Typography variant="h4">{t("training_pages.list_training_users")}</Typography>
      {usersToInscribe ? (
        <TableComponent
          header={[
            { title: t("training_pages.user_id"), style: { width: "5%" } },
            { title: t("user") },
            { title: t("course_name") },
            { title: t("price") },
            { title: t("actions") },
          ]}
          renderChildren={(userToInscribe) => (
            <TableRow key={userToInscribe.unique_key}>
              <TableCell>{userToInscribe.userId}</TableCell>
              <TableCell>{userToInscribe.fullname}</TableCell>
              <TableCell>{course.name}</TableCell>
              <TableCell>{course.price}</TableCell>
              <TableCell>
                {userToInscribe.bought ? (
                  <>
                    <Button
                      title={t("training_pages.training_bought", { source: `(${course.id})` })}
                      icon={<AssignmentTurnedInIcon />}
                      onClick={() => {}}
                    />
                    <Link to={`/training-users/user/details/${trainingId}/${userToInscribe.id}/${courseId}`}>
                      <Button
                        title={t("training_pages.checking_progress_for", { source: `(${course.id})` })}
                        icon={<PublishedWithChangesIcon />}
                      />
                    </Link>
                    {userToInscribe.hasCertificate ? (
                      <>
                        <Button
                          title={t("training_pages.download_certificate")}
                          icon={<GetAppIcon />}
                          onClick={() =>
                            openExportWindow(userToInscribe.trainingCourseId, userToInscribe.userId, onExportError)
                          }
                        />
                      </>
                    ) : null}
                  </>
                ) : (
                  <Button
                    title={t("training_pages.add_training_to_cart", {
                      id: course.id,
                      name: course.name,
                      price: `, ${course.price}`,
                    })}
                    icon={<AddShoppingCartIcon />}
                    onClick={() => shoppingCart.actions.add(course, userToInscribe.userId)}
                  />
                )}
              </TableCell>
            </TableRow>
          )}
          search={["userId", "fullname"]}
          pagination
          items={usersToInscribe}
        />
      ) : null}

      <Button title={t("navigate_back")} type="button" onClick={() => history.goBack()}>
        {t("training_pages.return_to_crew_trainings")}
      </Button>
    </>
  );
};

export default InscribeUser;
